import React from "react";
import BugForm from "./components/BugForm";
import "./index.scss";

const BugPage = () => {
  return (
    <div className="bug-page-wrapper">
      <div className="container">
        <div className="row">
          <div className="col-md-6 offset-md-3">
            <BugForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BugPage;
